import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import Container from "./Container";
import { Link } from "react-navi";
import Paginator from "./Paginator";

function CardsDisplay(props) {
  const { cards, pages, endpoint, searchParams } = props;

  // this array will be filled with  rows of template cards
  const rows = [];
  if (cards) {
    for (let i = 0; i < cards.length; i += 2) {
      rows[i] =
        i < cards.length - 1 ? ( // two templates per row
          <Row key={i} className=" d-flex justify-content-center">
            <Col>{cards[i]}</Col>
            <Col>{cards[i + 1]}</Col>
          </Row>
        ) : (
          // last machine needs to be in a single column so it's nicely centered
          <Row key={i} className=" d-flex justify-content-center">
            <Col className=" col-xs-12 col-sm-12 col-lg-6 col-xl-6 col-md-6">
              {cards[i]}
            </Col>
          </Row>
        );
    }
  }
  return (
    <React.Fragment>
      <Paginator
        params={searchParams}
        searchPrams={searchParams}
        endpoint={endpoint}
        pages={pages}
      />
      {rows.length > 0 ? (
        rows
      ) : (
        <h4 className="text-center font-weight-light">
          No templates available
        </h4>
      )}
      <Paginator params={searchParams} endpoint={endpoint} pages={pages} />
    </React.Fragment>
  );
}

export default CardsDisplay;



// WEBPACK FOOTER //
// ./src/views/components/CardsDisplay.jsx